import { z } from 'zod';

/**
 * Foto do avatar do viajante (#2640) — o único campo do perfil que o legado
 * (`business.users`) não guarda, então vive num store próprio do customer-api
 * (metadados no Mongo, bytes num bucket S3 privado) e sai no wire como URL
 * pré-assinada de vida curta (`CustomerProfileView.photoUrl`).
 *
 * O servidor decide o tipo pelos MAGIC BYTES do corpo, nunca pelo header — o
 * enum abaixo é o que ele aceita e o que o front oferece no seletor de arquivo.
 */
export const CustomerPhotoContentTypeSchema = z.enum(['image/jpeg', 'image/png', 'image/webp']);
export type CustomerPhotoContentType = z.infer<typeof CustomerPhotoContentTypeSchema>;

export const CUSTOMER_PHOTOS_MAX_IDS = 300;

/**
 * Batch de fotos para uma superfície onde COLEGAS aparecem (o board de
 * Solicitações, a busca de viajantes do QUEM). `viewerId` é o id de quem está
 * olhando — o `userId` numérico do token de chat ou o publicId; cada `id` é o
 * publicId do viajante (`RequestedTripView.traveler.id`) OU o id numérico de
 * origem (o roster do business só tem esse), e a resposta vem chaveada pelo id
 * como foi pedido. A regra "mesma empresa" é aplicada no customer-api, o único
 * que conhece a empresa dos dois lados; o BFF só costura.
 */
export const CustomerPhotosRequestSchema = z.object({
  viewerId: z.string().min(1),
  ids: z.array(z.string().min(1)).min(1).max(CUSTOMER_PHOTOS_MAX_IDS),
});
export type CustomerPhotosRequest = z.infer<typeof CustomerPhotosRequestSchema>;

/**
 * id pedido → URL pré-assinada, ou `null` quando o viajante não existe, não tem
 * foto ou não é da empresa de quem olha. As três razões colapsam de propósito:
 * o wire não revela se há foto que o viewer não pode ver. Todo id pedido
 * aparece como chave, para o BFF costurar sem `?? null` por item.
 */
export const CustomerPhotosResponseSchema = z.object({
  photos: z.record(z.string(), z.url().nullable()),
});
export type CustomerPhotosResponse = z.infer<typeof CustomerPhotosResponseSchema>;
